module.exports = __webpack_public_path__ + "img/sexfinder.70e085b.png";